import React from 'react';
import { useSelector } from 'react-redux';
import { SwiperSlide } from 'swiper/react';
import { ImageType } from '../../../../../shared/src/components/Image';
import { ThumbnailInLoadingState } from '../../GameThumbnails/ThumbnailInLoadingState';
import { GridPageStripGamesSwiper } from '../GridPageStripGamesSwiper';
import './GridPageStripGamesDesignTop10.css';

const MAX_NUMBER = 10;

const renderNumber = (index) => {
    return (
        <div className="grid-pages-strip-top-10-number">
            {index}
        </div>
    );
};

const renderPreloadThumbnails = () => {
    const gamesToRender = (new Array(MAX_NUMBER)).fill(undefined);

    return gamesToRender.map((gameId, index) => (
        <SwiperSlide key={`${gameId}-${index}`}>
            {renderNumber(index + 1)}

            <ThumbnailInLoadingState />
        </SwiperSlide>
    ));
};

const renderGamesThumbnails = (gamesToRender, renderFn) => {
    // Some games can not be rendered, keeping rendering index instead of array to show corrent number
    let renderedIndex = 0;

    const result = [];

    for (const gameId of gamesToRender) {
        const content = renderFn(gameId, {
            imageType: ImageType.VERTICAL_RECTANGLE,
        });
        if (content) {
            const slideResult = (
                <SwiperSlide key={gameId}>
                    {renderNumber(++renderedIndex)}

                    {content}
                </SwiperSlide>
            );
            result.push(slideResult);

            if (result.length === MAX_NUMBER) {
                break;
            }
        }
    }

    return result;
};

export const GridPageStripGamesDesignTop10 = ({ games, renderCasinoThumbnailFn, strip }) => {
    const { platformGamesReady } = useSelector((state) => state.app);
    const itemsToRender = platformGamesReady
        ? renderGamesThumbnails(games, renderCasinoThumbnailFn)
        : renderPreloadThumbnails();

    return (
        <GridPageStripGamesSwiper
            wrapperClassName="grid-pages-strip-top-10"
            strip={strip}
        >
            {itemsToRender}
        </GridPageStripGamesSwiper>
    );
};
